/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { AppInsights, Correlator } from "@microsoftit/telemetry-extensions-npm";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { config } from "../config";
import { createBrowserHistory } from "history";

export const telemetryProperties = {
  application: config.telemetry.application,
  serviceEndpoint: config.api.baseUrl,
  sessionId: config.telemetry.sessionId,
  environmentName: config.telemetry.environmentName,
};

interface AppInsightWrapper {
  appInsights: AppInsights,
  candidateId: string
}

const ConfigureHeartTelemetry = (): AppInsightWrapper => {
  const heartLogger: AppInsightWrapper ={
    appInsights : new AppInsights(),
    candidateId : config.telemetry.defaultCandidateId
  }
  heartLogger.appInsights.InitializeTelemetry(
    config.telemetry.environmentName,
    getAIKeyIfDebugEnable(),
    config.telemetry.serviceOffering,
    config.telemetry.serviceLine,
    config.telemetry.service,
    config.telemetry.componentName,
    config.telemetry.componentId,
    ""
  );

  const correlation = new Correlator();
  heartLogger.appInsights.AddMsitTelemetryInitializers(correlation, undefined);
  return heartLogger;
};

const getAIKeyIfDebugEnable = () => {
  return config.telemetry.enableHeartMetrics
    ? config.telemetry.instrumentationKey
    : "";
};

const createTelemetryService = () => {
  const browserHistory = createBrowserHistory({ basename: "" });
  const reactPlugin = new ReactPlugin();
  const aplicationInsights = new ApplicationInsights({
    config: {
      instrumentationKey: config.telemetry.instrumentationKey || "",
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  });

  aplicationInsights.loadAppInsights();
  return aplicationInsights.appInsights;
};


export const appInsights = createTelemetryService();
export const heartTelemetryLogger = ConfigureHeartTelemetry();
